import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { useAppConfig } from '../appConfig';
import { useParamsToGetUserId } from './useParamsToGetUserId';
import { MsalAuthErrorCode } from './types';
/**
 * This hook will attempt to silently sign in the user if they are already signed in.
 */
export const useSSO = () => {
    const idParams = useParamsToGetUserId();
    const config = useAppConfig();
    const { instance: msalApp, inProgress } = useMsal();
    if (inProgress === InteractionStatus.Startup) {
        msalApp
            .ssoSilent(Object.assign(Object.assign({}, idParams), { scopes: config.scopes }))
            .catch(err => {
            // This error is just MSAL telling us they blocked recursion, so we can ignore it.
            //
            // To make this call, MSAL opens a hidden iframe, requests our sign in page,
            // and then redirects *that hidden frame* back to our application to process.
            // You don't want to call this function again from within that iframe or it
            // can get the user stuck in a loop. In this case, MSAL throws a `block_iframe_reload`
            // error. If we catch this, we will ignore it.
            if (err.errorCode === MsalAuthErrorCode.block_iframe_reload) {
                // do nothing
                return Promise.resolve();
            }
            // We actually don't care if SSO fails, so we can ignore this error.
        });
    }
};
